import type { ChartSpec } from "@/types";
import { downloadBlob } from "@/lib/download";

const GENERIC_HEADINGS = new Set([
  "executive summary",
  "introduction",
  "overview",
  "summary",
  "background",
  "conclusion",
  "next steps",
  "table of contents",
]);

export function extractTitle(rawContent: string): string {
  const lines = rawContent.split("\n");
  for (const line of lines) {
    const h1 = line.match(/^#\s+(.+)/);
    if (h1) {
      const t = h1[1].trim().toLowerCase();
      if (!GENERIC_HEADINGS.has(t)) return h1[1].trim();
    }
  }
  for (const line of lines) {
    const h2 = line.match(/^##\s+(.+)/);
    if (h2) {
      const t = h2[1].trim().toLowerCase();
      if (!GENERIC_HEADINGS.has(t)) return h2[1].trim();
    }
  }
  return "Report";
}

export function parseChartMarkers(text: string): {
  cleanText: string;
  charts: ChartSpec[];
} {
  const charts: ChartSpec[] = [];
  const chartRegex = /<!--chart:(\{.*?\})-->/g;
  let match: RegExpExecArray | null;
  while ((match = chartRegex.exec(text)) !== null) {
    try {
      charts.push(JSON.parse(match[1]) as ChartSpec);
    } catch {
      // skip invalid chart data
    }
  }
  return { cleanText: text.replace(chartRegex, "").trim(), charts };
}

export async function triggerDownload(
  content: string,
  title: string,
  format: "pdf" | "docx",
  downloadFn: (content: string, title: string, token: string) => Promise<Blob>,
  token: string,
): Promise<void> {
  const blob = await downloadFn(content, title, token);
  downloadBlob(blob, title.replace(/\s+/g, "-").toLowerCase() + "." + format);
}
